<template>
  <div class="pt-4">
    <div class="px-2 pt-2">
      <v-expansion-panel v-for="(item, index) in acompanhamentos" :key="index" class="mb-3" @input="setLoteIdSelecionado(index)">
        <v-expansion-panel-content>
          <template v-slot:header>
            <div class="d-flex justify-space-between">
              <div>
                <span v-if="item.descricao" class="header-item pr-3">{{ item.lote }}</span>
                <span v-else class="header-item pr-3">{{ item.lote }}</span>
                <span class="pr-3">|</span>
                <v-tooltip v-if="item.descricao" top max-width=750>
                  <span slot="activator">{{ item.descricao | az-clip-text(50) }}</span>
                  <span>{{ item.descricao }}</span>
                </v-tooltip>
                <button v-else class="blue--text inline text-decoration-underline" @click.stop="verItens(index)">ver itens</button>
              </div>
              <div class="text-md-right pr-2">
                <span>{{ item.titulo }}</span>
              </div>
            </div>
          </template>
          <acompanhamento-tabela class="pb-2" :acompanhamento-detalhes="acompanhamentoDetalhes[index]" :situacao="item.titulo"/>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </div>
    <modal-ver-itens-grupo :exibir="exibirModalVerItens"
                           :lote="lote"
                           :itens-grupo="itensGrupo"
                           class="modal-ver-itens-grupo"
                           max-width="700"
                           @fecharModal="exibirModalVerItens=false"/>
  </div>
</template>
<script>
import {actionTypes} from '@/core/constants'
import AcompanhamentoTabela from '@/views/pages/commons/licitacao/detalhe/etapas-visualizacao/AcompanhamentoTabela'
import ModalVerItensGrupo from '@/views/components/ModalVerItensGrupo'

export default {
    name: 'LicitacaoVisualizacaoAcompanhamento',
    components: {
        AcompanhamentoTabela,
        ModalVerItensGrupo,
    },
    data() {
        return {
            exibirModalVerItens: false,
            licitacaoId: null,
            acompanhamentos: [],
            acompanhamentoDetalhes: [],
            itensGrupo: [],
            loteIdSelecionado: null,
            lote: null,
        }
    },
    async created() {
        await this.setLicitacaoId()
        await this.buscarAcompanhamentos()
    },
    methods:{
        async buscarAcompanhamentos(){
            const resultado = await this.$store.dispatch(actionTypes.BUSCAR_ACOMPANHAMENTO, this.licitacaoId)
            this.acompanhamentos = resultado
        },
        async buscarAcompanhamentosDetalhes(){
            if (this.loteIdSelecionado !== null) {
                const resultado = await this.$store.dispatch(actionTypes.BUSCAR_ACOMPANHAMENTO_DETALHE,
                    {licitacaoId: this.licitacaoId, loteId: this.loteIdSelecionado})
                this.$set(this.acompanhamentoDetalhes, this.acompanhamentos.findIndex(item => item.loteId === this.loteIdSelecionado), resultado)
            }
        },
        setLoteIdSelecionado(index){
            this.loteIdSelecionado = this.acompanhamentos[index].loteId
            this.buscarAcompanhamentosDetalhes()
        },
        setLicitacaoId(){
            this.licitacaoId = Number(this.$route.params.id)
        },
        verItens(index){
            this.lote = this.acompanhamentos[index].lote
            this.itensGrupo = this.acompanhamentos[index].itens
            this.exibirModalVerItens = true
        }
    }
}
</script>
<style lang="stylus">
.v-expansion-panel:has(.v-expansion-panel__container.v-expansion-panel__container--active)
  border-radius 5px !important
  .v-expansion-panel__header
      .header-item
        color: var(--v-primary-base)
.text-decoration-underline
  text-decoration: underline

</style>